export default {
  methods: {
    hasArrayValue(array) {
      return array ? array.length !== 0 : false
    },
    isEmptyArrayValue(array) {
      return array ? array.length === 0 : true
    },
    hasObjectValue(object) {
      return object ? Object.keys(object).length !== 0 : false
    },
    isEmptyObject(object) {
      return object ? Object.keys(object).length === 0 : true
    },
    hasString(input) {
      return input ? input.trim() !== "" : false
    },
    isEmptyString(input) {
      return input ? input.trim() === "" : true
    },
    isNotNumeric(number) {
      if (number === 0) return false
      return number ? isNaN(number) : true
    },
    isNumeric(number) {
      if (number === 0) return false
      return number ? !isNaN(parseFloat(number)) && isFinite(number) : false
    },
    isValidEmail(email) {
      const emailFormat = /^\s*\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w{2,}\s*$/
      return this.isEmptyString(email) ? false : emailFormat.test(email)
    },
    isInvalidEmail(email) {
      const emailFormat = /^\s*\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w{2,}\s*$/
      return this.isEmptyString(email) ? true : !emailFormat.test(email)
    },
    isValidPhoneNumber(phoneNumber) {
      const phoneFormat = /^0[0-9]{8,9}$/
      return this.isEmptyString(phoneNumber)
        ? false
        : phoneFormat.test(phoneNumber)
    },
    isInvalidPhoneNumber(phoneNumber) {
      const phoneFormat = /^0[0-9]{8,9}$/
      return this.isEmptyString(phoneNumber)
        ? true
        : !phoneFormat.test(phoneNumber)
    },
    isValidIpV4(ipAddress) {
      const ipAddressV4Format =
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      return ipAddressV4Format.test(ipAddress)
    },
    isInvalidIpV4(ipAddress) {
      const ipAddressV4Format =
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      return !ipAddressV4Format.test(ipAddress)
    },
    isValidIpV6(ipAddress) {
      const ipAddressV6Format =
        /(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/gi
      return ipAddressV6Format.test(ipAddress)
    },
    isInvalidIpV6(ipAddress) {
      const ipAddressV6Format =
        /(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/gi
      return !ipAddressV6Format.test(ipAddress)
    },
    isCountingNumber(number) {
      const countingFormat = /^[1-9]$|^[1-9][0-9]+$/
      return countingFormat.test(number)
    },
    isInteger(number) {
      const countingFormat = /^0|[0-9]*[1-9][0-9]*$/
      return countingFormat.test(number)
    },
    isPositiveInteger(value) {
      const positiveIntegerRegex = /^\d+$/;
      return (typeof value === 'string' || typeof value === 'number') && positiveIntegerRegex.test(String(value));
    },
    isComplexPassword(password) {
      let hasUpperCase = /[A-Z]/.test(password)
      let hasLowerCase = /[a-z]/.test(password)
      let hasNumbers = /\d/.test(password)
      let hasNonAlphas = /\W/.test(password)
      if (
        password.length < 8 ||
        hasUpperCase + hasLowerCase + hasNumbers + hasNonAlphas <= 3
      ) {
        return false
      } else {
        return true
      }
    },
    isNotComplexPassword(password) {
      let hasUpperCase = /[A-Z]/.test(password)
      let hasLowerCase = /[a-z]/.test(password)
      let hasNumbers = /\d/.test(password)
      let hasNonAlphas = /\W/.test(password)
      if (
        password.length < 8 ||
        hasUpperCase + hasLowerCase + hasNumbers + hasNonAlphas <= 3
      ) {
        return true
      } else {
        return false
      }
    },
    isValidThaiId(id) {
      if (!/^\d{13}$/.test(id)) {
        return false;
      }
  
      let sum = 0;
      for (let i = 0; i < 12; i++) {
        sum += parseInt(id.charAt(i)) * (13 - i);
      }
  
      const checkDigit = (11 - (sum % 11)) % 10;
      return checkDigit === parseInt(id.charAt(12));
    },
    isInvalidThaiId(id) {
      if (!/^\d{13}$/.test(id)) {
        return true;
      }
  
      let sum = 0;
      for (let i = 0; i < 12; i++) {
        sum += parseInt(id.charAt(i)) * (13 - i);
      }
  
      const checkDigit = (11 - (sum % 11)) % 10;
      return checkDigit !== parseInt(id.charAt(12));
    },
    
  },
}
